module.exports = __webpack_public_path__ + "img/logo_golf_row_color.c7913145.png";